import InputWithIcon from '@deliveroo/tools-component-library/dist/components/InputWithIcon';
import LayoutBox from '@deliveroo/tools-component-library/dist/components/LayoutBox';
import Heading from '@deliveroo/tools-component-library/dist/components/Heading';
import Button from '@deliveroo/tools-component-library/dist/components/Button';
import Text from '@deliveroo/tools-component-library/dist/components/Text';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';

import { compose } from 'redux';
import CenteredCardLayout from 'lib/components/CenteredCardLayout';
import withI18n from 'lib/hocs/withI18n';
import withTracking from 'lib/hocs/withTracking';
import styles from './styles.module.scss';

class ForgottenPasswordPage extends Component {
  static propTypes = {
    email: PropTypes.string,
    forgottenPassword: PropTypes.func.isRequired,
    tracker: withTracking.TYPE.isRequired,
    i18n: withI18n.TYPE.isRequired,
  };

  static defaultProps = {
    email: '',
  };

  state = {
    status: undefined,
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.props.tracker.track('clicked_element', {
      element_type: 'button',
      label: 'Reset password',
    });
    const { forgottenPassword } = this.props;
    const setStatus = (res) => this.setState({ status: res.status });

    return forgottenPassword({
      email: e.target.getElementsByTagName('input')[0].value,
    })
      .then(setStatus)
      .catch(setStatus);
  };

  backToLogin(e) {
    e.preventDefault();
    Router.push('/login');
  }

  renderResponseMessage(status) {
    const { i18n } = this.props;

    switch (status) {
      case undefined:
        return undefined;
      case 200:
        return (
          <Text>{i18n.gettext('password_reset.form.success_message')}</Text>
        );
      default:
        return (
          <Text color="red">
            {i18n.gettext('password_reset.form.generic_error')}
          </Text>
        );
    }
  }

  render() {
    const { i18n } = this.props;
    const { status } = this.state;
    const message = this.renderResponseMessage(status);

    return (
      <CenteredCardLayout>
        <form className={styles.form} onSubmit={this.onSubmit}>
          <Heading spacing="0 0 large 0" level={3}>
            {i18n.gettext('password_reset.form.title')}
          </Heading>
          {status !== 200 && (
            <div>
              <InputWithIcon
                spacing="0 0 medium 0"
                data-testid="email-input"
                defaultValue={this.props.email}
                placeholder={i18n.gettext(
                  'password_reset.form.email_input_placeholder',
                )}
                icon="email"
                type="email"
              />
              {message && (
                <LayoutBox spacing="0 0 medium 0">{message}</LayoutBox>
              )}
              <LayoutBox spacing="0 0 medium 0">
                <Button
                  label={i18n.gettext('password_reset.form.submit_label')}
                  className={styles.submitButton}
                />
              </LayoutBox>
            </div>
          )}

          {status === 200 && (
            <div>
              <LayoutBox spacing="0 0 medium 0">{message}</LayoutBox>
              <Button
                label={i18n.gettext('password_reset.form.back_to_login')}
                data-testid="back-button"
                onClick={this.backToLogin}
              />
            </div>
          )}
        </form>
      </CenteredCardLayout>
    );
  }
}

export default compose(withTracking, withI18n)(ForgottenPasswordPage);
